import { CHAIN_ID } from '@/constants/chain';
import { useAppSelector } from '@/hooks';
import _ from 'lodash';
import { useMemo } from 'react';
import { useNativeToken } from '../chain/hook';

export function useConfigData() {
  return useAppSelector((state) => {
    return state.config;
  });
}
export const useBackendChainConfig = (chainId: CHAIN_ID | undefined) => {
  const { backendChainsConfig } = useConfigData();
  return chainId && backendChainsConfig[chainId];
};

export const useTokensInfoConfig = (chainId: CHAIN_ID | undefined) => {
  const { chainTokensInfoConfig } = useConfigData();
  return chainId && chainTokensInfoConfig[chainId];
};
export const useMarginTokens = (chainId: CHAIN_ID | undefined) => {
  const tokensInfoConfig = useTokensInfoConfig(chainId);
  const nativeToken = useNativeToken(chainId);
  const marginTokens = useMemo(() => {
    const tokens = _.values(tokensInfoConfig?.marginTokenMap);
    if (nativeToken) {
      tokens.push(nativeToken);
    }
    return tokens;
  }, [nativeToken, tokensInfoConfig?.marginTokenMap]);
  return marginTokens;
};
